// Re-export from organized subfolder for backward compatibility.
export { AlaCarteMenuBuilder, type AlaCarteMenuBuilderProps } from './alacarte/alacarte-menu-builder';
